module.exports = __webpack_public_path__ + "img/eye-attention.dfb82f96.png";